<script lang="ts" setup>
import img1 from "@/assets/image/services/solarPanels/carousel-solar-ev-punjaca.png";
import img2 from "@/assets/image/services/solarPanels/carousel-solar-pametno-upravljanje.png";
import img3 from "@/assets/image/services/solarPanels/carousel-solar-projektovanje.png";
import img4 from "@/assets/image/services/solarPanels/carousel-solar-ugradnja.png";
import { $t } from "@/i18n";
import { useDefaultStore } from "@/store";
import { $te } from "@/assets/ts/helpers";

const store = useDefaultStore();
const carousel = computed(() => [
  {
    image: img1,
    text: $t("app.solarPanels.carousel.1"),
    active: true,
  },
  {
    image: img2,
    text: $t("app.solarPanels.carousel.2"),
    active: false,
  },
  {
    image: img3,
    text: $t("app.solarPanels.carousel.3"),
    active: false,
  },
  {
    image: img4,
    text: $t("app.solarPanels.carousel.4"),
    active: false,
  },
]);

useHead({
  title: `${$te("app.solarPanels.heading")} | ${store.SITE_NAME}`,
  meta: [
    {
      name: "title",
      content: `${$te("app.solarPanels.heading")} | ${store.SITE_NAME}`,
    },
    {
      name: "description",
      content: $te("app.solarPanels.paragraph1"),
    },
    { name: "robots", content: "index, follow" },
    {
      property: "og:title",
      content: `${$te("app.solarPanels.heading")} | ${store.SITE_NAME}`,
    },
    {
      property: "og:description",
      content: $te("app.solarPanels.paragraph1"),
    },
    { property: "og:site_name", content: store.SITE_NAME },
  ],
});
</script>

<template>
  <m-page class="bg-text-dark">
    <div class="mx-auto max-w-screen-xl">
      <services-page-heading :heading="$t('app.solarPanels.heading')"></services-page-heading>
      <services-paragraph class="mb-8 max-w-[779px]" :text="$t('app.solarPanels.paragraph1')"></services-paragraph>
      <base-button :text="$t('app.base.contactUs')" route-name="ContactPage" class="mb-12 md:mb-22" bg-color="text-light"></base-button>
      <services-paragraph class="mb-6 max-w-[779px]" :text="$t('app.solarPanels.paragraph2')"></services-paragraph>
      <carousel-comp v-if="!store.isWiderThan1307" :carousel="carousel">
        <template #default="{ item, active }">
          <services-image-card :text="item.text ?? ''" :image="item.image" :active="active"></services-image-card>
        </template>
      </carousel-comp>
      <template v-else> <services-wide-carousel :carousel="carousel"></services-wide-carousel> </template>
      <services-paragraph :text="$t('app.solarPanels.paragraph3')" class="mt-8"></services-paragraph>
      <services-paragraph :text="$t('app.solarPanels.paragraph4')"></services-paragraph>
    </div>
  </m-page>
</template>
